<script>
    import Select from "svelte-select";
    import { navigate } from "svelte-routing";
    import { paginateGroupByUser } from "../../../services/groupService";
    import GroupCard from "./GroupCard.svelte";
    import Table from "../Table.svelte";
    import Searchbar from "../../SearchBars/SearchBar.svelte";
    import { groupTableFilter } from "../../../stores/groupTableFilter";
    import { filterDefinedValues } from "../../../utils/filterDefinedValues";
    import { onDestroy, onMount } from "svelte";
    import { createColumnsFromQuery, stringifySortArray } from "../../../utils/sortFunction";
    import Button from "../../Button/Button.svelte";
    import { selectedActiveYear } from "../../../stores/selectedActiveYear";
    import { isAdmin } from "../../../stores/settingsStore";
    import toast from "svelte-french-toast";

    let totalPages;
    let groups = [];
    let totalCount;
    let isLoading= true;
    let columns = [
        { displayName: "Nome", fieldName: "name", isSortable: true, sortValue: "desc" },
        { displayName: "Tipologia", fieldName: "type" },
        { displayName: "Numero iscritti", fieldName: "membershipsCount" },
        { displayName: "Numero minimo iscritti", fieldName: "minSubscribersCount" },
        { displayName: "", fieldName: "" },
        { displayName: "", fieldName: "" },
    ];
    const groupTypeOptions = [
        { value: "NATIONAL", label: "Nazionale" },
        { value: "REGIONAL", label: "Regionale" },
        { value: "FEDERATION", label: "Federazione" },
        { value: "CIRCLE", label: "Circolo" },
    ]

    function updateSortFilter(sorts) {
        $groupTableFilter = { ...$groupTableFilter, sort: stringifySortArray(sorts)};
    }

    async function getGroupList(pagination) {
        isLoading = true;

        paginateGroupByUser(pagination).then((resp) => {
            isLoading = false;

            if(resp.status === 200 && resp?.data) {
                groups = resp.data.data;

                totalPages = Math.ceil(resp.data?.totalCount / $groupTableFilter?.size)
                totalCount = resp.data.totalCount;
            }

        }).catch((err) => {
            isLoading = false;

            toast.error(`Errore durante la ricerca, errore: ${err.toString()}`);
        })
    }

    const unsubscribeTableFilter = groupTableFilter.subscribe((filter) => {
        if (!filter) {
            return;
        }

        const urlSearchParams = new URLSearchParams(filterDefinedValues(filter));
        navigate(!urlSearchParams.size ? "" : `?${urlSearchParams.toString()}`, { replace: false });

        getGroupList(Object.fromEntries(urlSearchParams));
    });

    function updateFilterAndResetPage(key, value) {
        $groupTableFilter = { ...$groupTableFilter, page: 1, [key]: value }
    }

    let unsubscribeActiveYear;

    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = Object.fromEntries(urlParams);

        if (!filters.page) {  filters.page = "1" }
        if (!filters.size) {  filters.size = "50" }

        if (!!filters.sort) {
            columns = createColumnsFromQuery(filters.sort, columns);
        }

        $groupTableFilter = filters;

        unsubscribeActiveYear = selectedActiveYear.subscribe((year) => {
            $groupTableFilter  = { ...$groupTableFilter , year };
        });
    })

    onDestroy(() => {
        unsubscribeTableFilter();
        unsubscribeActiveYear();
    });
</script>

{#if !!$groupTableFilter}
    <Table
        bind:page={$groupTableFilter.page}
        bind:size={$groupTableFilter.size}
        bind:totalPages
        bind:totalCount
        bind:isLoading
        bind:rowCount={groups.length}
        bind:columns
        subject="Gruppi"
        on:sort={(e) => updateSortFilter(e.detail)}
    >
        <div class="flex flex-col md:flex-row items-center justify-between w-full gap-2" slot="actions">
            <div class="relative w-full max-w-full font-semibold text-3xl flex-grow flex-1">
                Gruppi
            </div>

            <div class="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
                {#if $isAdmin}
                    <Button
                        handleClick="{() => navigate('tree', {replace: true})}"
                        buttonClass="w-full md:w-44 bg-blueGray-500 text-white"
                        content="Vista albero"
                    />
                {/if}

                <Button
                    handleClick="{() => navigate('create', {replace: true})}"
                    buttonClass="w-full md:w-44 bg-lightBlue-500 text-white"
                    content="Crea gruppo"
                />
            </div>
        </div>

        <div slot="searchbar" class="flex flex-col gap-1 md:flex-row items-end z-10">
            <Searchbar
                placeholder="Filtra per nome del gruppo"
                value={$groupTableFilter.name}
                on:search={(e) => updateFilterAndResetPage("name", e.detail)}
                slot="searchbar"
            />

            <Select
                items={groupTypeOptions}
                floatingConfig={{placement: 'bottom-start'}}
                id="statusFilter"
                clearable="{true}"
                type= "text"
                containerStyles={`border: 1px solid #D8D4D4; max-height: 2rem !important; min-height: 2.75rem; border-radius: 0px`}
                placeholder="Seleziona filtro per la tipologia del gruppo"
                on:change={(e) => updateFilterAndResetPage("groupType", e.detail.value)}
                on:clear={() => updateFilterAndResetPage("groupType", undefined)}
                value={$groupTableFilter.groupType}
            />
        </div>

        <svelte:fragment slot="tableContent">
            {#each groups as group}
                <GroupCard group="{group}" on:delete={() => getGroupList($groupTableFilter)}/>
            {/each}
        </svelte:fragment>
    </Table>
{/if}